import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FootballState from "../state/football-state";
import { FragmentMessages } from "../../common/fragment-messages";
import PassResultType from "../enums/pass-result-type";
import ReceivedByPositionPref from "./position-pref/received-by-position-pref";

export default class PassComplete extends Fragment {
    constructor(receivedBy, receivedAt) {
        super();

        this.receivedBy = receivedBy;
        this.receivedAt = receivedAt;
        this.passResultCode = PassResultType.COMPLETE.code;

        this.requiredData = [
            {
                name: "receivedBy",
                type: FragmentDataType.Player,
                displayName: "Received By",
                title: (team) => `Received By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    new ReceivedByPositionPref(play, this).resolve()
            },
            {
                name: "receivedAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                requiredAfterNextState: [
                    FootballState.Tackle,
                    FootballState.OutOfBounds
                ]
            }
        ];
    }

    getFieldPosition() {
        return this.receivedAt;
    }

    getPlayers() {
        return [this.receivedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `complete to ${stringifier.firstInitial(
            this.receivedBy
        )} for ${stringifier.gain(
            summaryContext,
            summaryContext.fieldPosition,
            this.receivedAt
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.receivedAt || this.receivedAt === 0) {
            summaryContext.fieldPosition = this.receivedAt;
        }
        summaryContext.playerInPossession = this.receivedBy;
    }

    getFragmentTeamId() {
        return this.receivedBy?.teamId;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            receivedBy: playerReducer(this.receivedBy)
        };
    }
}
